import {IObjectData, IRouteDefinitionParams, ISyncField} from "../../index";
import {ErrorObject} from "../../error/ErrorObject";

interface ISyncFieldMutable {
    syncfield: KnockoutObservable<ISyncField | null>
    value: KnockoutObservable<string>
    dateValue: KnockoutObservable<string | null>
    errSyncfield: ErrorObject,
    errValue: ErrorObject,
    useComponent: KnockoutObservable<boolean>
}

interface IEventMessages {
    submit: string
    success: string
}

interface ILinkedObjectParams extends IRouteDefinitionParams{
    object: IObjectData
}

interface ISearchObjectRouteOptions {
    $resetFilters?: boolean
    roleid?: number
    showAll?: boolean
    systemid?: number
}